export function SAVE_REDIRECT(state, [redirect]){
    state.redirect = redirect
}

export function SAVE_TOKEN(state, [token]){
    state.token = token
}